import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import WithLogin from '../withLogin.component';

let worker;
if (process.env.NODE_ENV === 'production') {
    // use minified verion for production
    worker = require('pdfjs-dist/build/pdf.worker.min.js');
} else {
    worker = require('pdfjs-dist/build/pdf.worker.js');
}

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    worker,
    import.meta.url,
).toString();

const SCALE_STEP = 0.25;
const MAX_ZOOM = 5.0;
const MIN_ZOOM = 0.5;
const DEAULT_ZOOM = 1.5;

const ReportPreview = props => {
    const [zoom, setZoom] = useState(DEAULT_ZOOM);
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [loading, setLoading] = useState(true);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setLoading(false);
    }

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                <div style={{ border: '2px solid black' }}>
                    <Document
                        file={props.url}
                        onLoadSuccess={onDocumentLoadSuccess}>
                        <Page
                            pageNumber={pageNumber}
                            renderTextLayer={false}
                            scale={zoom}
                        />
                    </Document>
                </div>
            </div>
            <div
                style={{
                    position: 'sticky',
                    bottom: '-16px',
                    background: 'white',
                    gap: '0.5rem',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '1rem 0 0.5rem 0',
                }}>
                <div>
                    <Button
                        size="sm"
                        variant="outline-dark"
                        disabled={zoom >= MAX_ZOOM}
                        id="zoom-in-button"
                        onClick={() =>
                            setZoom(prevValue =>
                                Math.min(prevValue + SCALE_STEP, MAX_ZOOM),
                            )
                        }>
                        <ZoomInIcon />
                    </Button>
                </div>
                <Button
                    size="sm"
                    variant="outline-dark"
                    disabled={zoom <= MIN_ZOOM}
                    onClick={() =>
                        setZoom(prevValue =>
                            Math.max(prevValue - SCALE_STEP, MIN_ZOOM),
                        )
                    }>
                    <ZoomOutIcon />
                </Button>
                {!loading && props.showPagination && (
                    <Stack>
                        <Pagination
                            count={numPages}
                            variant="outlined"
                            shape="rounded"
                            disabled={loading}
                            onChange={(event, page) => {
                                setPageNumber(page);
                            }}
                        />
                    </Stack>
                )}
            </div>
        </div>
    );
};

export default WithLogin(ReportPreview);
